import { useMemo, useState } from 'react';
import { Select, Input, Button } from 'antd';
import { BREAKPOINTS, Container, Flex } from '@/ui';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FilterOutlined } from '@ant-design/icons';

export const ProductFilters = ({
  setCompanyFilter,
  setTypeFilter,
  setTermFilter,
  data,
  handleSearchFilter
}) => {
  const { t } = useTranslation();
  const [isBlockVisible, setIsBlockVisible] = useState(false);

  const productList = useMemo(() => (data ? data : null), [data]);

  function removeDuplicates(arr, key) {
    const seen = new Map();
    return arr.filter((obj) => {
      const value = obj[key];
      const trimmedValue = value !== null && value !== undefined ? String(value).trim() : value;
      if (seen.has(trimmedValue)) {
        return false;
      }
      seen.set(trimmedValue, true);
      return true;
    });
  }

  const productsCompanyList = useMemo(() => {
    if (productList) {
      const filteredProductCompanyList = removeDuplicates(productList, 'company');

      return filteredProductCompanyList
        .filter((product) => product.company)
        .map((product) => ({
          label: product.company,
          value: product.company
        }));
    } else {
      return [];
    }
  }, [productList]);

  const productsTermList = useMemo(() => {
    if (productList) {
      const filteredProductTermList = removeDuplicates(productList, 'term');
      return filteredProductTermList
        .filter((product) => product.term)
        .map((product) => ({
          label: product.term,
          value: product.term
        }));
    } else {
      return [];
    }
  }, [productList]);

  const productsTypeList = useMemo(() => {
    if (productList) {
      const filteredProductTypeList = removeDuplicates(productList, 'type');
      return filteredProductTypeList
        .filter((product) => product.type)
        .map((product) => ({
          label: product.type,
          value: product.type
        }));
    } else {
      return [];
    }
  }, [productList]);

  return (
    <>
      <Container $smdHidden>
        <Flex gap={8} wrap>
          <CustomSelect
            options={productsCompanyList}
            size='large'
            allowClear
            placeholder={t('Company')}
            onChange={setCompanyFilter}
          />

          <CustomSelect
            options={productsTypeList}
            size='large'
            allowClear
            placeholder={t('Type of Investments')}
            onChange={setTypeFilter}
          />

          <CustomSelect
            options={productsTermList}
            size='large'
            allowClear
            placeholder={t('Investment term')}
            onChange={setTermFilter}
          />

          <InputSearch
            size='large'
            placeholder={t('Search by title')}
            allowClear
            onSearch={handleSearchFilter}
          />
        </Flex>
      </Container>

      <Container $relative>
        <Container $hidden $smdVisible>
          <Button size='large' onClick={() => setIsBlockVisible(!isBlockVisible)}>
            <FilterOutlined />
          </Button>

          {isBlockVisible && (
            <Flex gap={8} $marginTop={8} wrap>
              <CustomSelect
                options={productsCompanyList}
                size='large'
                allowClear
                placeholder={t('Company')}
                onChange={setCompanyFilter}
              />

              <CustomSelect
                options={productsTypeList}
                size='large'
                allowClear
                placeholder={t('Type of Investments')}
                onChange={setTypeFilter}
              />

              <CustomSelect
                options={productsTermList}
                size='large'
                allowClear
                placeholder={t('Investment term')}
                onChange={setTermFilter}
              />

              <InputSearch
                size='large'
                placeholder={t('Search by title')}
                allowClear
                onSearch={handleSearchFilter}
              />
            </Flex>
          )}
        </Container>
      </Container>
    </>
  );
};

const CustomSelect = styled(Select)`
  width: 200px;

  @media (max-width: ${BREAKPOINTS.smd}px) {
    width: 100%;
  }
`;
const InputSearch = styled(Input.Search)`
  width: 200px;

  input {
    font-size: 14px !important;
  }

  @media (max-width: ${BREAKPOINTS.smd}px) {
    width: 100%;
  }
`;
